import * as React from 'react';

import Ribbon16 from './Ribbon16';

export const ribbon16 = () => <Ribbon16 />;

export default {
    title: 'Icon/Fill/Ribbon16',
    component: Ribbon16,
    parameters: {
        notes: "`import Ribbon16 from 'box-ui-elements/es/icon/fill/Ribbon16';`",
    },
};
